<template>
  <div class="w-full">
    <h2 class="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
      What brings you to Capino?
    </h2>
    <!-- <p class="text-gray-600 mb-6">We'll personalize your first test for you.</p> -->

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <OnboardingQuizCard
        v-for="reasonOption in reasonOptions"
        :key="reasonOption.value"
        :is-selected="selectedReason === reasonOption.value"
        :emoji="reasonOption.emoji"
        :title="reasonOption.label"
        @click="handleReasonSelection(reasonOption.value)"
      />
    </div>
  </div>
</template>

<script>
import OnboardingQuizCard from '@/components/Onboarding/OnboardingQuizCard.vue'

export default {
  name: 'OnboardingReasonStep',

  components: {
    OnboardingQuizCard
  },

  props: {
    selectedReason: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      reasonOptions: [
        { value: 'exam-soon', label: 'I have an exam soon', emoji: '📝' },
        {
          value: 'explanations',
          label: 'I want to learn with mistake explanations',
          emoji: '💡'
        },
        {
          value: 'all-grammar',
          label: 'I need all grammar in one place',
          emoji: '📚'
        },
        { value: 'other', label: 'Other / Just curious', emoji: '🤔' }
      ]
    }
  },

  methods: {
    handleReasonSelection(reason) {
      this.$emit('reason-selected', reason)
    }
  }
}
</script>
